import client from "./client";

export const trialApi = {
  start: () => client.post("/api/trial/start"),
  get: () => client.get("/api/trial"),
};
